import { omit, pick } from "lodash";
import { AccountModel, AccountType } from "../types/account";
import { ApiResponse } from "../types/api";
import { InvitationModel } from "../types/invitation";
import { UserModel } from "../types/user";
import Base from "./base";

class AccountAPI extends Base {
	constructor(token: string) {
		super(token, "/api/account");
	}

	async createPersonalAccount(account: AccountModel, user: UserModel): Promise<ApiResponse<AccountModel>> {
		return await this.postJsonWithQueryParams("", "POST", {
			...omit(account, ["id", "userId", "type"]),
			name: user.name, 
			emailAddress: user.email, 
			phoneNumber: user.phone, 
			type: AccountType.PERSONAL, 
		});
	}

	async createCompanyAccount(account: AccountModel): Promise<ApiResponse<AccountModel>> {
		return await this.postJsonWithQueryParams("", "POST", {
			...omit(account, ["id", "userId", "type"]),
			type: AccountType.COMPANY, 
		});
	}

	async updatePersonalAccount(
		account: AccountModel,
		user: UserModel
	): Promise<{
		accountId: string;
	}> {
		return await this.postJsonWithQueryParams("", "PATCH", {
			...pick(account, ["street", "zip", "city", "countryCode"]),
			name: user.name,
			emailAddress: user.email, 
			phoneNumber: user.phone,  
			type: AccountType.PERSONAL, 
		});
	}

	async updateCompanyAccount(account: AccountModel): Promise<ApiResponse<AccountModel>> {
		return await this.postJsonWithQueryParams("", "PATCH", {
			...omit(account, ["id", "userId"]),
			type: AccountType.COMPANY, 
		});
	}

	async deleteAccount(): Promise<ApiResponse> {
		return await this.postJsonWithQueryParams("", "DELETE");
	}

	async getInvitations(): Promise<ApiResponse<InvitationModel[]>> {
		return await this.fetchJsonWithQueryParams("/invitation", "GET");
	}

	async inviteUserToActiveAccount(phoneNumber: string): Promise<ApiResponse<AccountModel>> {
		return await this.postJsonWithQueryParams("/invitation", "POST", { phoneNumber });
	}

	async revokeAccountInvitation(accountId: string, phoneNumber: string): Promise<ApiResponse> {
		return await this.postJsonWithQueryParams("/invitation", "DELETE", { accountId, phoneNumber });
	}

}

export default AccountAPI;
